import { env } from "../../fe-ui/utils/env";
import * as ContentApi from "./service";
// import { request } from "../../fe-ui/utils/request";

const api = new ContentApi.Api({
  baseURL: `${env("CONTENT_API_ROOT")}/api`,
});

const instance = api.instance;

instance.interceptors.request.use((config) => {
  return config;
});

const ContentApiClient = {
  ...api,
};

const SlugApiClient = {
  getPlainTextPage(slug: string, locale: string) {
    return instance.get(`/slugify/slugs/plain-text-page/${slug}?locale=${locale}`).then(({ data }) => data);
  },
  getStaticPage(slug: string, locale: string) {
    return instance
      .get(
        `/slugify/slugs/landing-page/${slug}?locale=${locale}&populate[content][populate]=items.*&populate[content][populate]=items.media,media,media2,containerProps&populate[seo]=*`
      )
      .then(({ data }) => data);
  },
  getSeo(slug: string, locale: string) {
    return instance.get(`/slugify/slugs/seo/${slug}?locale=${locale}`).then(({ data }) => data);
  },
};

export { ContentApiClient, SlugApiClient };
